import { Avatar, IconButton, Typography } from "@mui/material";
import { ButtonContainer, StatusBadge } from "../styles";

type Props = {
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  name: string;
  initials: string;
  isAway?: boolean;
};

const ToolbarMenuButton = ({
  onClick,
  name,
  initials,
  isAway = false,
}: Props) => (
  <ButtonContainer data-testid="toolbar-menu-button" onClick={onClick}>
    <IconButton>
      <StatusBadge invisible={!isAway} color="error">
        <Avatar sx={{ bgcolor: (theme) => theme.palette.primary.main }}>
          {initials}
        </Avatar>
      </StatusBadge>
    </IconButton>
    <Typography color="#000000DE">{name}</Typography>
  </ButtonContainer>
);

export default ToolbarMenuButton;
